import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import css from './lib-header.css';

const asset = (name: string) => new URL(`../wago-icons-svg/${name}.svg`, import.meta.url).href;

/** Application header with consumer-defined actions. */
@customElement('lib-header')
export class LibHeader extends LibElement {
  protected override get hostFocusSelector(): string { return 'button'; }
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];
  @property({ attribute: 'application-name' }) applicationName = '';

  override render() {
    return html`<div class="ui-lib-header">
      <div class="left-items">
        <button type="button" class="wago-icon header-item" @click=${() => this.emit('lib-header-logo')}>
          <img src=${asset('WagoLogo')} alt="wago" class="wago-logo">
          ${this.applicationName ? html`<span class="application-name">${this.applicationName}</span>` : nothing}
        </button>
      </div>
      <div class="right-items">
        <slot></slot>
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-header': LibHeader; }
}
